export default __webpack_public_path__ + "static/media/avatar_placeholder.8f9d0a10.png";